import { createThunkRoutine } from 'redux-thunk-routine';

export const FetchReleaseNotesRoutine = createThunkRoutine('releaseNotes/FETCH_RELEASE_NOTES');
export const CreateReleaseNoteRoutine = createThunkRoutine('releaseNotes/CREATE_RELEASE_NOTE');
export const UpdateReleaseNoteRoutine = createThunkRoutine('releaseNotes/UPDATE_RELEASE_NOTE');
export const PublishReleaseNoteRoutine = createThunkRoutine('releaseNotes/PUBLISH_RELEASE_NOTE');
export const DeleteReleaseNoteRoutine = createThunkRoutine('releaseNotes/DELETE_RELEASE_NOTE');
export const FetchLatestVersionRoutine = createThunkRoutine('releaseNotes/FETCH_LATEST_VERSION');

